module.exports = "/src/views/player/reports/images/ra-logo.png";